import { SxProps, Theme } from "@mui/material";
import {
  APP_BACKGROUND_COLOR,
  APP_COLOR,
  BORDER_COLOR,
  FONT_FAMILY,
  TEXT_COLOR,
} from "../../theme";

export const legalPageShellSx: SxProps<Theme> = {
  backgroundColor: APP_BACKGROUND_COLOR,
  minHeight: "100vh",
  py: { xs: 4, md: 7 },
  px: { xs: 2, sm: 3, md: 4 },
};

export const legalPageContainerSx: SxProps<Theme> = {
  maxWidth: "920px",
  mx: "auto",
};

export const legalPageHeaderSx: SxProps<Theme> = {
  mb: 3,
  px: { xs: 0.5, md: 1 },
};

export const legalPageTitleSx: SxProps<Theme> = {
  color: "white",
  fontFamily: FONT_FAMILY,
  fontWeight: 700,
  fontSize: { xs: "28px", md: "36px" },
  lineHeight: 1.15,
  mb: 1,
};

export const legalPageMetaSx: SxProps<Theme> = {
  color: TEXT_COLOR,
  fontFamily: FONT_FAMILY,
  fontSize: "14px",
};

export const legalDocumentCardSx: SxProps<Theme> = {
  backgroundColor: "rgba(255,255,255,0.03)",
  border: `1px solid ${BORDER_COLOR}`,
  borderRadius: "18px",
  px: { xs: 2, sm: 3, md: 4 },
  py: { xs: 2.5, sm: 3, md: 4 },
  boxShadow: "0 16px 40px rgba(0,0,0,0.18)",
};

export const legalDocumentBodySx: SxProps<Theme> = {
  color: TEXT_COLOR,
  fontFamily: FONT_FAMILY,
  fontSize: { xs: "15px", md: "16px" },
  lineHeight: 1.85,
  textAlign: "left",
  "& p": {
    color: TEXT_COLOR,
    fontFamily: FONT_FAMILY,
    fontSize: { xs: "15px", md: "16px" },
    lineHeight: 1.85,
    mt: 0,
    mb: 2.25,
  },
  "& a": {
    color: APP_COLOR,
    textDecoration: "none",
    fontWeight: 600,
  },
  "& a:hover": {
    textDecoration: "underline",
  },
  "& ul": {
    listStyle: "none",
    pl: 0,
    mt: 3,
    mb: 1,
  },
  "& ul li": {
    color: "white",
    fontFamily: FONT_FAMILY,
    fontSize: { xs: "18px", md: "20px" },
    fontWeight: 700,
    lineHeight: 1.4,
    letterSpacing: "0.01em",
  },
  "& ol": {
    pl: { xs: 3, md: 3.5 },
    mt: 1,
    mb: 2.5,
  },
  "& ol li": {
    color: TEXT_COLOR,
    fontFamily: FONT_FAMILY,
    fontSize: { xs: "15px", md: "16px" },
    lineHeight: 1.85,
    mb: 1,
    pl: 0.5,
  },
  "& strong": {
    color: "white",
  },
};
